import { createServer } from 'miragejs'
import { hiveApiUrl } from './firebase'

createServer({
  routes() {
    this.namespace = 'mock'
    this.logging = false
    this.get('/company-info', () => {
      return {
        data: {
          company: {
            displayName: 'The Jonah Group Limited',
            logoUrl: 'https://logo.clearbit.com/jonahgroup.com',
            theme: {
              background: '#f1eee6',
              onBackground: '#000000',
              onPrimary: '#FFFFFF',
              onSecondary: '#ffffff',
              onSurface: '#000000',
              primary: '#4a90e2',
              secondary: '#494551',
              surface: '#FFFFFF',
            },
            companyId: 'kj38qAENzpjJ9CIWfFG6',
          },
          resource: {
            address: '123 Fake St., Ontario, Canada A1A 1A1',
            appointmentTypes: {
              '4ZMcqAENzpjJ9CIWfFG6': {
                appointmentLength: 120,
                appointmentTypeId: '4ZMcqAENzpjJ9CIWfFG6',
                description: 'Our super duper long boi',
                displayName: {
                  en: 'Extended Session',
                  fr: 'Extended Session in French',
                },
              },
              '4ZMcqAENzpjJ9CIWfFG5': {
                appointmentLength: 90,
                appointmentTypeId: '4ZMcqAENzpjJ9CIWfFG6',
                description: 'Super long boi',
                displayName: {
                  en: 'Session',
                  fr: 'Session in French',
                },
              },
              '4ZMcqAENzpjJ9CIWfFG4': {
                appointmentLength: 60,
                appointmentTypeId: '4ZMcqAENzpjJ9CIWfFG6',
                description: 'Long boi',
                displayName: {
                  en: 'Less than a session',
                  fr: 'Less than a session in French',
                },
              },
              '4ZMcqAENzpjJ9CIWfFG3': {
                appointmentLength: 30,
                appointmentTypeId: '4ZMcqAENzpjJ9CIWfFG6',
                description: 'Boi',
                displayName: {
                  en: 'Much less than a session',
                  fr: 'Much less than a session in French',
                },
              },
            },
            description: {
              en: 'English desc',
              fr: 'French desc',
            },
            displayName: {
              en: 'EnglishName',
              fr: 'FrenchName',
            },
            endDate: '2021-09-29',
            operationExceptionDates: ['2021-12-25'],
            operationHours: [
              {
                day: 'Tuesday',
                times: 'CLOSED',
              },
              {
                day: 'Monday',
                times: '10:00AM - 06:00PM',
              },
            ],
            resourceId: 'W4GO36mkL670RFYWQt15',
            startDate: '2021-09-26',
            mapParams: {
              lat: 43.64512,
              lng: -79.3964,
            },
          },
        },
        message: 'success',
      }
    })
    this.get(
      '/resource-availability/:company/:resourceId/:appointmentDate/:duration/:appointmentTypeId',
      () => {
        return {
          data: {
            startTimes: [
              '08:00',
              '09:00',
              '10:00',
              '11:00',
              '12:00',
              '13:00',
              '14:00',
              '15:00',
              '16:00',
            ],
            timeBlocks: [
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              false,
              true,
              true,
              true,
              true,
              true,
              true,
              true,
              true,
              true,
              false,
              false,
              false,
              false,
              false,
              false,
            ],
          },
        }
      },
    ),
      this.get('/appointment/:companyId/:bookingId', () => {
        return {
          data: {
            resource: {
              resourceId: 'W4GO36mkL670RFYWQt15',
              displayName: {
                en: 'EnglishName',
                fr: 'FrenchName',
              },
              description: {
                en: 'English location desc',
                fr: 'French location desc',
              },
              address: '123 Fake St., Ontario, Canada A1A 1A1',
            },
            appointmentType: {
              displayName: {
                en: 'English Appointment Display Name',
                fr: 'French Appointment Display Name',
              },
              description: {
                en: 'English Appointment Description',
                fr: 'French Appointment Description',
              },
            },
            startTime: 'Fri, 08 Oct 2021 15:00:00 GMT',
            endTime: 'Fri, 08 Oct 2021 15:30:00 GMT',
            tzRegion: 'America/Toronto',
          },
        }
      }),
      this.post('/create/:company', () => {
        return {
          data: {
            bookingId: 'j8T3B37LZBEfTiTuIfcS',
          },
          message: 'success',
        }
      }),
      this.post('/cancel/:company', () => {
        return {
          data: {
            bookingId: 'j8T3B37LZBEfTiTuIfcS',
          },
          message: 'success',
        }
      })
    this.passthrough(hiveApiUrl + '/**')
  },
})
